import React from "react";
import { Button } from "@revvsales/components";

const NotesHeader = ({ addNote }) => (
  <div className="notes-header">
    <span data-test="notesheader-right-pane-title" className="right-pane-title">
      Notes
    </span>

    <Button
      data-test="notesheader-add-new-note-button"
      className="revv-btn-secondary-sm"
      onClick={() => addNote()}>
      Add new note
    </Button>
  </div>
);

export default NotesHeader;



// WEBPACK FOOTER //
// ./src/components/Notes/NotesHeader.js